import { TelemetryLoggerProvider } from '@trinity/observability-web/react';
import { logger } from '@/telemetry';

/** Routes errors reported from `@trinity/chat-components` into the app's telemetry (OpenTelemetry, plus Sentry if enabled). */
export const LoggerProvider = ({ children }: { children: React.ReactNode }) => {

  return (
    <TelemetryLoggerProvider logger={logger}>
      {children}
    </TelemetryLoggerProvider>
  );
};
